export default __webpack_public_path__ + "static/media/otherAngle.3e54d386.jpg";